"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var HeaderFlexPane_1 = require("./HeaderFlexPane");
var PersonaControl_1 = require("owa-persona/lib/components/PersonaControl");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var owa_common_strings_1 = require("owa-strings/owa-common-strings");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var Persona_1 = require("office-ui-fabric-react/lib/Persona");
var mobx_react_1 = require("mobx-react");
var signout_1 = require("../actions/signout");
var styles = require('./HeaderPane.scss');
var ConsumerLiveEditProfilePageLink = 'https://account.microsoft.com/profile';
var ConsumerLiveAccountSettingsPageLink = 'https://account.microsoft.com';
var MeCardPane = /** @class */ (function (_super) {
    tslib_1.__extends(MeCardPane, _super);
    function MeCardPane() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onEditProfileClicked = function () {
            window.open(ConsumerLiveEditProfilePageLink, '_blank');
        };
        _this.onViewAccountClicked = function () {
            window.open(ConsumerLiveAccountSettingsPageLink, '_blank');
        };
        _this.onSignoutClicked = function () {
            signout_1.signout();
        };
        return _this;
    }
    MeCardPane.prototype.componentWillUnmount = function () {
        this.props.onDismiss();
    };
    MeCardPane.prototype.render = function () {
        var userConfiguration = getUserConfiguration_1.default();
        return (React.createElement(HeaderFlexPane_1.default, { title: function () { return owa_common_strings_1.default.myAccount; }, onDismiss: this.props.onDismiss, content: React.createElement("div", null,
                React.createElement(PersonaControl_1.default, { name: userConfiguration.SessionSettings.UserDisplayName, emailAddress: userConfiguration.SessionSettings.UserEmailAddress, size: Persona_1.PersonaSize.small, showPersonaDetails: true, hexConsumerIdForUser: userConfiguration.HexCID, className: styles.persona }),
                React.createElement("ul", { className: styles.actions },
                    React.createElement("li", null,
                        React.createElement(Button_1.CommandButton, { onClick: this.onEditProfileClicked, text: owa_common_strings_1.default.editProfile, className: styles.action })),
                    React.createElement("li", null,
                        React.createElement(Button_1.CommandButton, { onClick: this.onViewAccountClicked, text: owa_common_strings_1.default.viewAccount, className: styles.action })),
                    React.createElement("li", null,
                        React.createElement(Button_1.CommandButton, { onClick: this.onSignoutClicked, text: owa_common_strings_1.default.signOut, className: styles.action })))) }));
    };
    MeCardPane = tslib_1.__decorate([
        mobx_react_1.observer
    ], MeCardPane);
    return MeCardPane;
}(React.Component));
exports.default = MeCardPane;
//# sourceMappingURL=MeCardPane.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/header/owa-header-pane/lib/components/MeCardPane.js
// module id = 6210
// module chunks = 38